import axios from 'axios';

const state = {
    user: null,
    contrat: null,
    tarifs: null,
    erreur: null,
};

const getters = {
    isAuthenticated: state => !!state.user,
    stateContrat: state => state.contrat,
    stateTarifs: state => state.tarifs,
    stateUser: state => state.user,
    stateErreur: state =>state.erreur,
};

const actions = {
    async getContrat({commit, state}) {
        axios.get(`/contrat?api_token=${state.user.token}`)
        .then(response => commit('setContrat', response.data))
        .catch(() =>  commit('setContrat', null))
    },

    async getTarifs({commit}) {
        let response = await axios.get('/tarification/2025')
        await commit('setTarifs', response.data)
    },

    async logIn({commit}, user) {
        await commit('setErreur', null)

        let response = await axios.post('/login', user, { validateStatus: false })

        switch(response.status) {
            case 404:
                await commit('setErreur', response.data.error)
                break
            case 200:
                await commit('setUser', response.data.data)
                break
        }
    },

    async logOut({commit}) {
        let user = null
        commit('logOut', user)
    },

    /**
     * Enregistre un contrat sur le serveur pour paiement
     *
     */
     async saveContrat({state, dispatch}, contrat, locaux) {
        const url = state.contrat === null || state.contrat.numero === undefined ? 'create' : `${state.contrat.numero}/update`

        axios.post(`/contrats/${url}?api_token=${state.user.token}`, {'contrat': contrat, 'locaux': locaux, 'code': state.user.code})
        .then(() => dispatch('getContrat'))
        .catch((err) => console.error(err))
     },
};

const mutations = {
    setUser(state, user) {
        state.user = user
    },

    setContrat(state, contrat) {
        state.contrat = contrat
    },

    setTarifs(state, tarifs) {
        state.tarifs = tarifs;
    },

    setErreur(state, erreur) {
        state.erreur = erreur
    },

    logOut(state) {
        state.user = null
        state.contrat = null
    },
};

export default {
    state,
    getters,
    actions,
    mutations
};
